import { currentVersion } from './asset-versions.js';

/**
 * A tile brush's pieces at its current version, shaped for the tile sheet and
 * the draw preview: the outputs of the version the brush shows, one per slot.
 * A brush keeps every version (an app may be pinned to an older one), so a slot
 * a newer version dropped never leaks in from an earlier one.
 * @param {import('./asset-versions.js').AssetVersion[]} versions every version of the brush
 * @returns {Array<{ layer_name: string, file_url: string }>}
 */
export function currentTileBrushTiles(versions) {
    const version = currentVersion(versions);
    if (!version) return [];
    return (version.outputs || [])
        .map((o) => ({ layer_name: o.role, file_url: o.file.url }))
        .sort((a, b) => a.layer_name.localeCompare(b.layer_name));
}
